import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import { Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { preventDefault } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import InternalTransferEditViewModel from "viewModels/finance/internalTransfers/internalTransferEditViewModel";

const InternalTransferEditView: ViewComponent<InternalTransferEditViewModel> = observer(({ vm }) => {
  let input;
  if (vm.editedProperty === "amount") {
    input = <Input target={vm.item} property={vm.editedProperty} step={0.01} type="number" className="text-right" />;
  } else if (vm.editedProperty) {
    input = <Input target={vm.item} property={vm.editedProperty} className="text-right" />;
  }

  return (
    <Form onSubmit={preventDefault(vm.save)}>
      <Form.Row>
        <Col>{input}</Col>
        <Col xs="auto" className="align-self-top">
          <Button
            type="submit"
            iconLeft={IconType.Check}
            variant="success"
            size="sm"
            className="rounded"
            disabled={vm.busyWatcher.isBusy}
          />
        </Col>
        <Col xs="auto" className="align-self-top">
          <Button
            key="close"
            disabled={vm.busyWatcher.isBusy}
            iconLeft={IconType.Cross}
            variant="danger-inverted"
            size="sm"
            className="rounded"
            onClick={vm.onClose}
          />
        </Col>
      </Form.Row>
    </Form>
  );
});

registerView(InternalTransferEditView, InternalTransferEditViewModel);
